export default function enhancePostImages() {
    const figures = document.querySelectorAll('figure.wp-caption');

    // Prima passata: trova solo le figure zoomabili
    const zoomableFigures = [];

    figures.forEach((figure) => {
        const img = figure.querySelector('img');
        if (!img) return;

        const transferableClasses = [
            'is-zoomable'
        ];

        transferableClasses.forEach((className) => {
            if (img.classList.contains(className)) {
                figure.classList.add(className);
            }
        });

        if (img.classList.contains('is-zoomable')) {
            zoomableFigures.push(figure);
        }
    });

    const hasGallery = zoomableFigures.length > 1;

    // Seconda passata: costruisci link/lightbox solo per le zoomabili
    zoomableFigures.forEach((figure) => {
        const img = figure.querySelector('img');
        if (!img) return;

        const captionEl = figure.querySelector('figcaption');
        const caption = captionEl ? captionEl.textContent.trim() : '';

        let link = img.closest('a');
        const fullUrl = img.dataset.full || img.currentSrc || img.src;

        if (!link) {
            link = document.createElement('a');
            link.href = fullUrl;
            img.parentNode.insertBefore(link, img);
            link.appendChild(img);
        } else if (!link.getAttribute('href')) {
            link.setAttribute('href', fullUrl);
        }

        link.classList.add('glightbox');

        // Gallery solo se ci sono almeno 2 immagini zoomabili
        if (hasGallery) {
            link.setAttribute('data-gallery', 'post-images');
        } else {
            link.removeAttribute('data-gallery');
        }

        if (caption) {
            link.setAttribute('data-description', caption);
        }

        //link.setAttribute('data-width', '80vw');
        link.setAttribute('data-height', '80vh');
        link.setAttribute('data-draggable', 'false');

        if (!figure.querySelector('.viewLargePhoto')) {
            const viewBtn = document.createElement('button');
            viewBtn.type = 'button';
            viewBtn.classList.add('viewLargePhoto');
            viewBtn.innerHTML = `<i class="fa-thin fa-circle-plus fa-lg"></i> View`;

            figure.appendChild(viewBtn);

            viewBtn.addEventListener('click', (e) => {
                e.preventDefault();
                link.click();
            });
        }
    });

    if (typeof GLightbox === 'function' && document.querySelector('a.glightbox')) {
        GLightbox({
            selector: 'a.glightbox',
            touchNavigation: true,
            loop: hasGallery,
            openEffect: 'zoom',
            closeEffect: 'fade'
        });
    }
}